import React, { useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../main.css";

function SingleResult({ fillData }) {
  const [randomIndex] = useState(Math.floor(Math.random() * 6));
  const randomFacts = useRef({
    fact0: "non-corrosive",
    fact1: "freeze-resistant to -35° F",
    fact2: "non-toxic",
    fact3: "biodegradable",
    fact4: "water soluble",
    fact5: "animal food grade safe",
  });

  return (
    <div>
      {/* // <Alert className="mt-3 d-flex justify-content-center" bg="light"> */}
      <Alert className="pb-0 brdr-rg-green">
        <Alert.Heading className="pb-0">
          <Row className="pb-0">
            <Col className="text-center">
              <h3 className="pb-0">Tire Size: {fillData.tireSize}</h3>
            </Col>
          </Row>{" "}
          <hr className="hr-rg-green pt-0 mt-0" />
          <Row>
            <Col className="text-center">
              {Math.round(fillData.USGals)} US Gallons/Tire
            </Col>
            <Col className="text-center">
              {Math.round(fillData.liters)} Liters/Tire
            </Col>
            <Col className="text-center">
              {Math.round(fillData.impGals)} Imperial Gallons/Tire
            </Col>
          </Row>{" "}
          <Row className="pt-4">
            <Col className="text-center">
              Adding the suggested amount will add{" "}
              <strong>
                {Math.round(fillData.lbs)} lbs/{Math.round(fillData.kgs)} kgs{" "}
              </strong>
              of weight per tire and fill your tire 75% full
            </Col>
          </Row>
          {/* </Alert.Heading>
        </Alert> */}
        </Alert.Heading>
        <hr className="hr-rg-green" />
        <p className="text-center">
          Fun fact: Did you know that Beet Juice is{" "}
          {randomFacts.current[`fact${randomIndex}`]}?
        </p>
        <Row className="pt-3 pb-2">
          <Col md className="text-md-left text-center">
            {/* <Col sm={12} md={6}> */}
            <Button
              href="https://www.rimguardsolutions.com/contact-us/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-rg-purple text-center float-md-left"
            >
              Contact Rim Guard
            </Button>
          </Col>
          <Col md className="text-md-left text-center">
            {/* <Col sm={12} md={6}> */}
            <Button
              href="https://www.rimguardsolutions.com/find-a-dealer/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-center btn-rg-purple float-md-right mt-md-0 mt-3"
            >
              Find a Local Rim Guard Dealer
            </Button>{" "}
          </Col>
        </Row>
      </Alert>
    </div>
  );
}

export default SingleResult;
